import styles from "./appleSigninButton.module.scss";
import AppleIcon from "@icons/appleIcon.svg";

export function AppleSigninButton(props: Props) {
  const { label, className, ...rest } = props;
  return (
    <button
      className={styles["appleButton"]}
      data-testid="select-apple-method"
      {...rest}
    >
      <AppleIcon />
      {label}
    </button>
  );
}

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  label: string;
}
